<template>
  <v-form v-model="valid">
    <v-row>
      <v-col>
        <label class="och-label">Attribute</label>
        <div data-cy="listFilter-advanced-form-attributeSelect">
          <v-autocomplete
            :items="attributeListFiltered"
            :rules="[validateHasValue]"
            item-text="label"
            item-value="name"
            outlined
            return-object
            v-model="filterTermActive.attribute"
          ></v-autocomplete>
        </div>
      </v-col>

      <v-col>
        <label class="och-label">Operator</label>
        <div data-cy="listFilter-advanced-form-operatorSelect">
          <v-select
            :disabled="!attribute"
            :items="operatorListFiltered"
            :rules="[validateHasValue]"
            item-text="label"
            outlined
            return-object
            v-model="filterTermActive.operator"
          ></v-select>
        </div>
      </v-col>
    </v-row>

    <label class="och-label">Value(s)</label>

    <template v-if="!elementTypeFilterInputName">
      <p>Must select an attribute before specifying a value for comparison</p>
    </template>
    <template v-else>
      <div class="mt-3" data-cy="listFilter-advanced-form-valueInput-null">
        <v-checkbox label="Is null" v-model="isNull"></v-checkbox>
      </div>
      <div data-cy="listFilter-advanced-form-valueInput">
        <component
          :attribute="attribute"
          :is="elementTypeFilterInputName"
          v-model="filterTermActive.value"
          v-if="!isNull"
        ></component>
      </div>
    </template>

    <v-btn
      @click="addFilterTerm"
      class="mb-8 mt-1"
      :disabled="!isValid"
      color="primary"
      data-cy="listFilter-advanced-form-submit"
      outlined
      small
    >
      <v-icon class="mr-2" size="14">fas fa-plus</v-icon>Add Filter
    </v-btn>
  </v-form>
</template>

<script>
import {
  operatorDoesNotEqual,
  operatorDoesNotInclude,
  operatorEquals,
  operatorIncludes,
  validateHasValue,
} from "@/lib/componentUtil";

import * as listFilterAdvancedComponent from "./listFilterAdvancedComponent";

const operatorList = [
  { label: "Equals", fn: operatorEquals },
  { label: "Does not equal", fn: operatorDoesNotEqual },
  {
    fn: operatorIncludes,
    label: "Contains",
    elementTypeRestrictionList: [
      "SelectFk",
      "SelectFkMultiple",
      "TextField",
      "TextFieldDEA",
      "TextFieldEmail",
      "TextFieldNPI",
      "TextFieldNumeric",
    ],
  },
  {
    fn: operatorDoesNotInclude,
    label: "Does not contain",
    elementTypeRestrictionList: [
      "SelectFk",
      "SelectFkMultiple",
      "TextField",
      "TextFieldDEA",
      "TextFieldEmail",
      "TextFieldNPI",
      "TextFieldNumeric",
    ],
  },
];

const elementTypeFilterInputMap = {
  SelectFk: "SelectFk",
  SelectFkMultiple: "SelectFkMultiple",
  TextField: "TextField",
  TextFieldDEA: "TextField",
  TextFieldEmail: "TextField",
  TextFieldNPI: "TextField",
  TextFieldNumeric: "TextField",
  YesNo: "YesNo",
};

export default {
  components: {
    ...listFilterAdvancedComponent,
  },
  computed: {
    attribute() {
      const {
        filterTermActive: { attribute },
      } = this;

      return attribute;
    },
    elementTypeFilterInputName() {
      const { attribute } = this;

      if (!attribute) {
        return;
      }

      const { elementType } = attribute;

      return elementTypeFilterInputMap[elementType];
    },
    isValid() {
      const {
        valid,
        isNull,
        filterTermActive: { value },
      } = this;

      if (!valid) {
        return false;
      }
      if (isNull) {
        return true;
      }
      if (value === null || value === undefined) {
        return false;
      }

      return true;
    },
    operatorListFiltered() {
      const { attribute } = this;

      if (!attribute) {
        return [];
      }

      const { elementType } = attribute;

      return operatorList.filter(({ elementTypeRestrictionList }) => {
        if (!elementTypeRestrictionList) {
          return true;
        }

        return elementTypeRestrictionList.includes(elementType);
      });
    },
  },
  data() {
    return {
      isNull: false,
      valid: false,
    };
  },
  methods: {
    addFilterTerm() {
      const { filterTermActive } = this;
      this.isNull = false;

      this.$emit("add-filter-term", filterTermActive);
    },
    validateHasValue,
  },
  props: {
    attributeListFiltered: {
      required: true,
      type: Array,
    },
    filterTermActive: {
      required: true,
      type: Object,
    },
  },
  watch: {
    isNull(newVal) {
      if (!newVal) {
        return;
      }
      this.filterTermActive.value = null;
    },
  },
};
</script>
